import { render, staticRenderFns } from "./TenancyUserDetail.vue?vue&type=template&id=466b53ab&scoped=true&"
import script from "./TenancyUserDetail.vue?vue&type=script&lang=js&"
export * from "./TenancyUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./TenancyUserDetail.vue?vue&type=style&index=0&id=466b53ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b53ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('466b53ab')) {
      api.createRecord('466b53ab', component.options)
    } else {
      api.reload('466b53ab', component.options)
    }
    module.hot.accept("./TenancyUserDetail.vue?vue&type=template&id=466b53ab&scoped=true&", function () {
      api.rerender('466b53ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/tenants/TenancyUserDetail.vue"
export default component.exports